function isWeekend(date = new Date()) {
  return date.getDay() === 6 || date.getDay() === 0;
}

function isDaylightSavings(date) {
  return date.getTimezoneOffset() < Math.max(new Date(0, 1).getTimezoneOffset(), new Date(6, 1).getTimezoneOffset());
}

const DAYS_OF_WEEK = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

class OrderCountdown extends HTMLElement {
  constructor() {
    super();

    const holidayDatesString = this.getAttribute('data-countdown-holidays');
    const productPrice = this.getAttribute('data-countdown-product-price');
    this.shippingSaleMessage = this.getAttribute('data-countdown-title');

    this.currentVipTier = this.getAttribute('data-current-vip-tier');
    this.isInternational = this.getAttribute('data-is-international');
    this.isPrintful = this.getAttribute('data-is-printful');
    this.isClearance = this.getAttribute('data-is-clearance') === 'true';

    if (productPrice) {
      this.price = productPrice / 100;
    }

    if (holidayDatesString) {
      this.holidays = holidayDatesString.split(',').map((dateString) => {
        const date = new Date(Date.parse(dateString));
        date.setDate(date.getDate() + 1);
        return date;
      })
    }

    this.shippingMethod = this.getShippingMethod();

    const today = new Date();
    const hourOffset = isDaylightSavings(today) ? 20 : 21;
    let expiredDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), hourOffset, 45, 0, 0));
    this.shipDay = 'today';
    const deadlinePassed = today.getTime() >= expiredDate.getTime();

    if (deadlinePassed || this.isHoliday(today) || isWeekend(expiredDate)) {
      expiredDate = this.getNextValidDay(expiredDate);
      this.shipDay = expiredDate.getDate() - today.getDate() === 1 ? 'tomorrow' : DAYS_OF_WEEK[expiredDate.getDay()];
    }

    this.todayBanner = document.querySelector('[data-shipping-today]');
    this.setExpiredDate(expiredDate);
  }

  setExpiredDate(expiredDate) {
    const today = new Date();
    this.timeRemaining = expiredDate.getTime() - today.getTime();

    if (this.timeRemaining > 0) {
      if (this.todayBanner && this.shipDay === 'today') {
        this.todayBanner.classList.add('hero-product__shipping-banner--visible')
      }
      this.start();
    }
  }

  getShippingMethod() {
    let shippingMethod = '';
    const vipTier = this.isClearance ? null : this.currentVipTier;

    switch (vipTier) {
      case 'silver':
        shippingMethod = "Free two-day shipping in the US";
        break;
      case 'gold':
      case 'platinum':
        shippingMethod = "Free overnight shipping";
        break;
      default:
        shippingMethod = 'In stock and Shipping Now';
        break;
    }

    if (this.shippingSaleMessage && this.shippingSaleMessage !== '') {
      shippingMethod = this.shippingSaleMessage;
    }

    return shippingMethod;
  }

  getTime() {
    return {
      days: Math.floor(this.timeRemaining / 1000 / 60 / 60 / 24),
      hours: Math.floor(this.timeRemaining / 1000 / 60 / 60) % 24,
      minutes: Math.floor(this.timeRemaining / 1000 / 60) % 60,
      seconds: Math.floor(this.timeRemaining / 1000) % 60
    };
  }

  update() {
    const time = this.getTime();
    
    const dayPlural = time.days > 1 ? 's' : '';
    const hourPlural = time.hours > 1 ? 's' : '';
    const minutePlural = time.minutes > 1 ? 's' : '';

    if (this.todayBanner && this.shipDay !== 'today') {
      this.todayBanner.classList.remove('hero-product__shipping-banner--visible');
    }

    let timer;
    if (time.days > 0) {
      timer = `${time.days} day${dayPlural} ${time.hours} hour${hourPlural}`;
    } else if (time.hours > 0) {
      timer = `${time.hours} hour${hourPlural} ${time.minutes} minute${minutePlural}`;
    } else {
      timer = `${time.minutes} minute${minutePlural} ${time.seconds} seconds`;
    }

    this.innerHTML = `
      <div>
        <span class="product-shipping-details__title">
          ${this.getShippingMethod()}
        </span>
        <span>
          Order within <span class="order-countdown__timer">${timer}</span> to have it shipped <b>${this.shipDay}</b>.
        </span>
      </div>
    `;
  }

  start() {
    this.update();

    const intervalId = setInterval(() => {
      this.timeRemaining -= 1000;
      if (this.timeRemaining < 0) {
        clearInterval(intervalId);
      } else {
        this.update();
      }
    }, 1000);
  }

  isHoliday(date) {
    return this.holidays ?
      this.holidays.some((holiday) => holiday.toDateString() === date.toDateString())
      : false;
  }

  getNextValidDay(date) {
    let currentDate = date;
    currentDate.setDate(currentDate.getDate() + 1);
    if (this.isHoliday(currentDate) || isWeekend(currentDate)) {
      this.getNextValidDay(currentDate);
    }
    return currentDate;
  }
}

customElements.define('order-countdown', OrderCountdown);

class PrintfulCountdown extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector('[data-printful-content]');
    this.start();
  }

  async waitForElement(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  update() {
    const edt = document.querySelector('.edt');
    if (edt) {
      this.content.innerHTML = edt.innerHTML;
    }
  }

  async start() {
    await this.waitForElement('.edt');
    this.update();
  }
}

customElements.define('printful-countdown', PrintfulCountdown);
